import { BookkeepingAccount } from './general-bookkeeping';
import { VATBook } from './vat-bookkeeping';

export interface RtDeviceSetting {
  id: string;
  description: string | null;
  vatRateAccounts: Record<string, string> | null;
  createdAt: string;
  updatedAt: string;
  counterpart?: { id: string } | null;
  vatBook?: VATBook | null;
  defaultSalesAccount?: BookkeepingAccount | null;
}

export interface RtDeviceSettingPayload {
  counterpartId: string;
  description?: string | null;
  vatRateAccounts?: Record<string, string> | null;
  vatBookId?: string | null;
  defaultSalesAccountId?: string | null;
}

export const RtDeviceSettingQueryKeys = {
  all: ['rt-device-settings'] as const,
  company: (companyId: string) => [...RtDeviceSettingQueryKeys.all, companyId] as const,
};
